import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TeamMemberRow } from "../teamViewConfig";
import styles from "./TeamView.module.scss";

export const UserCell = ({
    row,
}: CellContext<ViewTableFeatures, TeamMemberRow, string>) => {
    const member = row.original;

    if (member.type === "invite") {
        return (
            <div className={styles.userCard}>
                <header>{member.email}</header>
                <small className="text-grey">Pending invite</small>
            </div>
        );
    }

    return (
        <div className={styles.userCard}>
            <header>{member.user.name}</header>
            <small className="text-grey">{member.user.email}</small>
        </div>
    );
};
